import { useLocation } from 'react-router-dom';

import { useCustomSWR } from 'hooks/useCustomSWR';
import { apiUrls } from 'services/api-urls';
import { fetcher } from 'services/fetcher';
import {
  DefaultProductListingType,
  GroupedProductListingType,
} from 'types/ProductListing/ProductListing';

type ReturnType = {
  data?: ApiResponseType;
  error?: Error;
  isValidating?: boolean;
};

type ApiResponseType = DefaultProductListingType | GroupedProductListingType;

export default function useProductListing(): ReturnType {
  const { pathname, state } = useLocation();

  const { data, error, isValidating } = useCustomSWR<ApiResponseType>(
    apiUrls.getListing(pathname),
    fetcher,
    {
      initialData: state?.searchApiData,
      revalidateOnFocus: false,
      keepPreviousData: true,
    }
  );

  return {
    data,
    error,
    isValidating,
  };
}
